export const SCREEN_WIDTH_THRESHOLD = 1480;
class RangeItem {
    public min: number;
    public max: number;
    public label: string;

    constructor(min: number, max: number, label: string) {
        this.min = min;
        this.max = max;
        this.label = label;
    }

    public isValueInRange(value: number): boolean {
        return this.min <= value && this.max >= value;
    }
}
export const PRICE_RANGE_MAP: Array<RangeItem> = [
    new RangeItem(0, 4_999, "< $5K"),
    new RangeItem(5_000, 49_999, "$5K - $50K"),
    new RangeItem(50_000, 249_999, "$50K - $250K"),
    new RangeItem(250_000, Number.MAX_SAFE_INTEGER, "> $250K"),
] as const;

export function getPriceRangeLabel(price: number): string {
    if (typeof price !== "number" || Number.isNaN(price)) {
        return "N/A";
    }

    return PRICE_RANGE_MAP.find((rangeItem) => rangeItem.isValueInRange(price)).label;
}
